import { render, staticRenderFns } from "./Voir_livreur.vue?vue&type=template&id=4e331c0d&"
import script from "./Voir_livreur.vue?vue&type=script&lang=js&"
export * from "./Voir_livreur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports